import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader.model';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  show = false;
  private subscription!: Subscription;
  constructor(private loaderService: LoaderService, private ref: ChangeDetectorRef) { }
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
        this.ref.detectChanges();
      });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
